import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Lightbulb, Zap, Info, X } from 'lucide-react';
import { FeatureHintDef } from '../../data/featureHints';
interface FeatureHintProps {
  hint: FeatureHintDef | null;
  onDismiss: () => void;
}
export function FeatureHint({
  hint,
  onDismiss
}: FeatureHintProps) {
  if (!hint) return null;
  const getIcon = () => {
    switch (hint.icon) {
      case 'sparkles':
        return <Sparkles size={16} className="text-indigo-400" data-id="element-2098" />;
      case 'lightbulb':
        return <Lightbulb size={16} className="text-amber-400" data-id="element-2099" />;
      case 'zap':
        return <Zap size={16} className="text-emerald-400" data-id="element-2100" />;
      case 'info':
        return <Info size={16} className="text-blue-400" data-id="element-2101" />;
      default:
        return <Info size={16} className="text-blue-400" data-id="element-2102" />;
    }
  };
  // Banner variant is the primary one for now
  if (hint.variant === 'banner') {
    return <AnimatePresence data-id="element-2103">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="absolute top-0 left-0 right-0 z-50 px-4 py-3" data-id="element-2104">
          <div className="max-w-4xl mx-auto flex items-center justify-between bg-indigo-950/40 backdrop-blur-md border border-indigo-500/20 rounded-xl shadow-lg shadow-indigo-900/20 overflow-hidden relative" data-id="element-2105">
            {/* Left gradient border */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-indigo-500 to-violet-500" data-id="element-2106" />

            <div className="flex items-center gap-3 pl-4 py-2" data-id="element-2107">
              <div className="p-1.5 bg-slate-900/50 rounded-lg shrink-0" data-id="element-2108">
                {getIcon()}
              </div>
              <div className="flex items-center gap-2 flex-wrap" data-id="element-2109">
                <span className="text-sm font-bold text-slate-100" data-id="element-2110">
                  {hint.title}
                </span>
                <span className="text-sm text-slate-300 hidden sm:inline" data-id="element-2111">
                  —
                </span>
                <span className="text-sm text-slate-300" data-id="element-2112">
                  {hint.description}
                </span>
                {hint.isNew && <span className="ml-2 px-1.5 py-0.5 bg-emerald-500/20 text-emerald-400 text-[10px] font-bold rounded-full uppercase tracking-wider" data-id="element-2113">
                    Nuevo
                  </span>}
              </div>
            </div>

            <div className="flex items-center gap-2 pr-3 py-2 shrink-0" data-id="element-2114">
              <button onClick={onDismiss} className="text-xs font-medium text-indigo-300 hover:text-indigo-200 hover:bg-indigo-900/30 px-2 py-1 rounded transition-colors" data-id="element-2115">
                Entendido
              </button>
              <button onClick={onDismiss} className="p-1 text-slate-400 hover:text-slate-200 hover:bg-slate-800 rounded-md transition-colors" data-id="element-2116">
                <X size={14} data-id="element-2117" />
              </button>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>;
  }
  return null;
}